import React from "react";
import useScrollToTop from "./../../../hooks/useScollToTop";

import useServicesMunicipauxAdmin from "./hooks/useServicesMunicipauxAdmin";

import ServicesMunicipauxHero from "./components/ServicesMunicipauxHero";
import ServicesMunicipauxStatsGrid from "./components/ServicesMunicipauxStatsGrid";
import ServicesMunicipauxFiltersPanel from "./components/ServicesMunicipauxFiltersPanel";
import ServicesMunicipauxList from "./components/ServicesMunicipauxList";
import ServicesMunicipauxFormDrawer from "./components/ServicesMunicipauxFormDrawer";
import ServicesMunicipauxPreviewDrawer from "./components/ServicesMunicipauxPreviewDrawer";
import ServicesMunicipauxDeleteDrawer from "./components/ServicesMunicipauxDeleteDrawer";

export default function ServicesMunicipauxAdmin() {
  useScrollToTop();
  const services = useServicesMunicipauxAdmin();

  return (
    <div className="mx-auto w-full max-w-[1600px] px-1 pb-10 sm:px-2 lg:px-0">
      <ServicesMunicipauxHero
        stats={services.stats}
        loading={services.loading}
        onCreate={services.openCreate}
      />

      {services.notice ? (
        <div className="mt-5 rounded-[1.5rem] border border-emerald-200 bg-emerald-50 px-5 py-4 text-sm font-bold text-emerald-800 shadow-sm dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300">
          {services.notice}
        </div>
      ) : null}

      {services.error ? (
        <div className="mt-5 rounded-[1.5rem] border border-rose-200 bg-rose-50 px-5 py-4 text-sm font-bold text-rose-800 shadow-sm dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300">
          {services.error}
        </div>
      ) : null}

      <ServicesMunicipauxStatsGrid
        stats={services.stats}
        loading={services.loading}
      />

      <ServicesMunicipauxFiltersPanel
        q={services.q}
        categorie={services.categorie}
        typeFilter={services.typeFilter}
        stateFilter={services.stateFilter}
        publicFilter={services.publicFilter}
        withGps={services.withGps}
        limit={services.limit}
        onChangeQ={services.setQ}
        onChangeCategorie={services.changeCategorie}
        onChangeTypeFilter={services.changeTypeFilter}
        onChangeStateFilter={services.changeStateFilter}
        onChangePublicFilter={services.changePublicFilter}
        onChangeWithGps={services.changeWithGps}
        onChangeLimit={services.changeLimit}
        onSubmit={services.onSubmitSearch}
        onReset={services.resetFilters}
        onRefresh={services.fetchData}
        loading={services.loading}
      />

      <ServicesMunicipauxList
        items={services.items}
        loading={services.loading}
        total={services.total}
        page={services.page}
        totalPages={services.totalPages}
        actionId={services.actionId}
        onPageChange={services.setPage}
        onPreview={services.openPreview}
        onEdit={services.openEdit}
        onToggleActive={services.onToggleActive}
        onTogglePublic={services.onTogglePublic}
        onAskDelete={services.openDelete}
      />

      <ServicesMunicipauxFormDrawer
        open={services.formOpen}
        form={services.form}
        fieldErrors={services.fieldErrors}
        saving={services.saving}
        isEdit={!!services.currentId}
        onClose={services.closeForm}
        onChange={services.updateFormField}
        onSave={services.onSave}
      />

      <ServicesMunicipauxPreviewDrawer
        open={!!services.previewItem}
        item={services.previewItem}
        onClose={services.closePreview}
        onEditFromPreview={services.openEditFromPreview}
      />

      <ServicesMunicipauxDeleteDrawer
        open={!!services.deleteItem}
        item={services.deleteItem}
        deleting={services.deleting}
        onClose={services.closeDelete}
        onConfirm={services.onDelete}
      />
    </div>
  );
}